import { alpha, css, styled } from '@mui/material/styles';

import { palette } from '@tgg/ui';

export const StyledCarouselBanner = styled('div')`
    ${({ theme }) => css`
        .swiper {
            ${theme.breakpoints.up('desktop')} {
                max-width: ${theme.tggSpacing(320)};
                height: ${theme.tggSpacing(125)};
            }
        }

        .swiper-slide {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            ${theme.breakpoints.up('desktop')} {
                height: ${theme.tggSpacing(125)};
            }
        }

        .swiper-slide::after {
            position: absolute;
            inset: 0;
            pointer-events: none;
            content: '';
            background: linear-gradient(
                to bottom,
                ${alpha(theme.palette.other.black, 0)} 0%,
                ${alpha(theme.palette.other.black, 0.4)} 100%
            );
        }

        .progressBar {
            width: ${theme.tggSpacing(16)};
            border-radius: ${theme.tggSpacing(90)};
        }

        .MuiLinearProgress-bar {
            transition: none !important;
        }

        .MuiLinearProgress-root {
            cursor: pointer;
            background: ${palette.grey[50]} !important;
        }

        .bannerImage {
            aspect-ratio: 1 / 1;
        }
    `}
`;

export const StyledButtonBaseContainer = styled('div')`
    max-width: ${({ theme }) => theme.tggSpacing(110)};
    margin: ${({ theme }) => theme.tggSpacing([6, 'auto', 0, 'auto'])};

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        min-width: ${({ theme }) => theme.spacing(80)};
    }
`;

export const StyledProgressBar = styled('div')`
    position: absolute;
    bottom: ${({ theme }) => theme.tggSpacing(6)};
    z-index: 10;
    display: flex;
    column-gap: ${({ theme }) => theme.tggSpacing(2.5)};
    justify-content: center;
    width: 100%;
`;

export const StyledSlideContent = styled('div')`
    position: absolute;
    bottom: ${({ theme }) => theme.tggSpacing(11)};
    z-index: 10;
    padding: 0 ${({ theme }) => theme.tggSpacing(6)};

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        padding: 0 ${({ theme }) => theme.tggSpacing(16)};
    }
`;

export const StyledAutoplayButtonWrapper = styled('div')`
    position: absolute;
    top: ${({ theme }) => theme.tggSpacing(2)};
    right: ${({ theme }) => theme.tggSpacing(2)};
    z-index: 10;
`;

export const StyledSubText = styled('h3')`
    ${({ theme }) => theme.typography.text_23_bold_lh_28_desktop_25};
    ${({ theme }) => css`
        margin: ${theme.tggSpacing([4, 0, 0, 0])};
        color: ${palette.common.white};
    `}
`;

export const StyledTitle = styled('h1')`
    ${({ theme }) => theme.typography.text_28_bold_lh_30_desktop_36_lh_40};
    ${({ theme }) => css`
        margin: ${theme.tggSpacing(0)};
        color: ${palette.common.white};
    `}
`;

export const StyledPromoPill = styled('div')`
    ${({ theme }) => theme.typography.text_14_bold_lh_20_desktop_16_lh_24};
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: max-content;
        height: ${theme.tggSpacing(7)};
        padding: ${theme.tggSpacing([1, 2])};
        margin: 0 auto ${theme.tggSpacing(4)};
        background: ${palette.common.white};
    `}
`;

export const StyledNavigationButtons = styled('div')`
    position: absolute;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: ${({ theme }) => theme.tggSpacing([0, 3])};
    pointer-events: none;
`;

export const StyledNavigationButton = styled('div')`
    pointer-events: auto;
`;

export const StyledVideo = styled('video')`
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
`;
